





























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import { IUser } from "@/models/users";
import { DataModules } from "@/store/modules/data";
import { mapState, mapGetters } from "vuex";
import { IState } from "@/store";

@Component({
  components: {
    "wallet-balance": () =>
      import("@/components/app/global/wallets/walletBalance.vue")
  },
  computed: {
    ...mapState({
      user(state: IState) {
        return state.user;
      }
    }),
    ...mapGetters({
      canTopUp: `data/${DataModules.CLIENTS}/canTopUp`
    })
  }
})
export default class ClientAccountCreditView extends Vue {
  @Prop({ required: true })
  public client!: IClient;

  public user!: IUser;

  public async topUp() {
    const topUpModal = await this.$store.dispatch(
      `data/${DataModules.WALLETS}/openTopUpModal`,
      {
        props: {
          client: this.client
        },
        events: {
          success: () => {
            // @ts-ignore
            this.$refs.walletBalance.getBalance();
            topUpModal.close();
          }
        }
      }
    );
  }

  public get canTopUpAccountCredit() {
    return this.$store.getters["data/clients/canTopUpAccountCredit"](
      this.client
    );
  }
}
